import { EVENT_USER_ID, SET_NO_VIEWERS, SET_USER_COUNTRY, USERNAME_FOUND, USERNAME_NOT_FOUND, USER_ID } from "../constants/authContants"

export const setUsername = (username) => async(dispatch) => {
    dispatch({
        type: USERNAME_FOUND,
        payload: username
    })
}

export const setCountry = (country) => async(dispatch) => {
    dispatch({
        type: SET_USER_COUNTRY,
        payload: country
    })
}

export const setNoOfViewers = (no) => async(dispatch) => {
    dispatch({
        type: SET_NO_VIEWERS,
        payload: no
    })
}

export const usernameNotFound = () => async(dispatch) => {
    dispatch({
        type: USERNAME_NOT_FOUND,
        payload: ''
    })
}


export const storeUserId = (id) => async(dispatch) => {
    dispatch({
        type: USER_ID,
        payload: id
    })
}

export const storeEventUserId = (id) => async(dispatch) => {
    dispatch({
        type: EVENT_USER_ID,
        payload: id
    })
    
    localStorage.setItem("auth", JSON.stringify({lvcconnectEventUserId: id}))    
}